import React from 'react';
import {
  Pagination,
  ReferenceManyField,
} from 'react-admin';

import { Card, Grid } from '@mui/material';

import { ResourceTypes } from '../../constants/resourceTypes';
import AuditDatagrid from './AuditDatagrid';

const AuditResourceList = ({
  resourceType,
}: {
  resourceType: ResourceTypes;
}) => (
  <Grid container>
    <Grid size={12}>
      <Card variant="outlined">
        <ReferenceManyField
          reference="audit-tracks"
          target="resource.id"
          filter={{ 'resource.type': resourceType }}
          sort={{ field: 'date', order: 'DESC' }}
          pagination={<Pagination />}
        >
          <AuditDatagrid hideResourceColumns />
        </ReferenceManyField>
      </Card>
    </Grid>
  </Grid>
);

export default AuditResourceList;
